import Card from '../../../shared/Card';
import { Box, Flex, Stack } from '../../../shared/layouts';
import { formatAppointmentDate } from '../../../../utils/dateHelpers';
import { useTranslation } from 'react-i18next';
import Button from '../../../shared/Button';
import useIconLibrary from '../../../../hooks/useIconLibrary';
import { createEvent } from "ics";
import { saveAs } from 'file-saver';

const ConfirmationCard = ({ selectedAppointment, startDate, selectedLocation = null }) => {
  const { duration_without_buffer, name } = selectedAppointment;

  const { t } = useTranslation();
  const { CalendarIcon } = useIconLibrary();
  const { day = '', time: startTime = '', fullDate: fullStartDate } = formatAppointmentDate(startDate);
  const endTime =
    fullStartDate && duration_without_buffer
      ? fullStartDate.clone().add(duration_without_buffer, 'minutes').format('HH:mm')
      : '';

  const event = {
    title: name,
    start: [fullStartDate?.year(), fullStartDate?.month() + 1, fullStartDate?.date(), fullStartDate?.hour(), fullStartDate?.minute()],
    duration: { minutes: duration_without_buffer },
    location: selectedLocation?.name,
  }

  const handleDownloadIcs = () => {
    createEvent(event, (error, value) => {
      const blob = new Blob([value], { type: "text/plain;charset=utf-8" });
      saveAs(blob, name.toLowerCase().replace(/ /g, '_') + ".ics");
    });
  };

  return (
    <Card>
      <Stack space={'m'}>
        <div>
          <Box
            fontScale={'l'}
            fontWeight={'bold'}
            css={{ ':first-letter': { textTransform: 'uppercase' } }}
          >
            {day}
          </Box>
          <Box fontWeight={'bold'}>{`${startTime} - ${endTime} ${t(
            'uur'
          )}`}</Box>
        </div>
        <Box>
          {t(
            'Zorg ervoor dat je goed voorbereid het gesprek in gaat en je alle documenten tijdig in jouw portaal klaar hebt staan.'
          )}
        </Box>
        <Button variant={'anchor'} css={{ padding: 0 }} onClick={handleDownloadIcs}>
          <Flex alignItems={'center'}>
            <CalendarIcon
              width={'2rem'}
              height={'2rem'}
              css={({ colors, space }) => ({
                marginRight: space.s,
                fill: colors?.secondary
              })}
            />
            {t('Voeg toe aan agenda')}
          </Flex>
        </Button>
      </Stack>
    </Card>
  );
};

export default ConfirmationCard;
